module.exports = __webpack_public_path__ + "img/userF.041fc55e.svg";